import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/tileWhite.svg'
import _imports_3 from '@/assets/tilePrimary.svg'
import _imports_4 from '@/assets/listsWhite.svg'
import _imports_5 from '@/assets/listsPrimary.svg'
import _imports_6 from '../assets/tooltip.svg'
import _imports_7 from '../assets/foldersIconPrimary.svg'
import _imports_8 from '../assets/fileIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "flex items-center justify-between flex-wrap" }
const _hoisted_3 = { class: "flex items-center justify-center space-x-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row-reverse items-center"
}
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "flex flex-end parent-toggle-border rounded p-px" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "my-2"
}
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "mt-5 bg-white rounded" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_17 = { class: "flex items-center justify-center w-full h-16 mt-4 tableCornerRadius bg-white" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "absolute box-container-position white-box z-index-icons" }
const _hoisted_23 = { class: "flex items-center justify-center gap-3" }
const _hoisted_24 = { class: "text-size-ten font-semibold yellow-text text-center" }
const _hoisted_25 = ["onMouseenter"]
const _hoisted_26 = { class: "h-10 w-full text-sm font-semibold m-2 ellipsis-multiline-2 cursor-pointer" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "bg-white absolute z-50 group-hover:opacity-100 rounded tooltipwidth border-lightgrey border pointer-events-none" }
const _hoisted_29 = { class: "px-2" }
const _hoisted_30 = {
  key: 1,
  class: "h-28 rounded flex items-center justify-center text-xs"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 0,
  class: "search-results"
}
const _hoisted_33 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  src: _imports_7,
  alt: "folder",
  class: "cursor-pointer"
}
const _hoisted_36 = {
  key: 1,
  src: _imports_8,
  alt: "file",
  class: "cursor-pointer"
}
const _hoisted_37 = { class: "h-10 w-full text-sm font-semibold text-center m-2 ellipsis-multiline-2 cursor-pointer" }
const _hoisted_38 = {
  key: 1,
  class: "h-28 rounded flex items-center justify-center text-xs"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_newTable = _resolveComponent("newTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Documents")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.viewMode === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex", _ctx.documentsDataJSON.length === 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                }, [
                  (_ctx.documentsDataJSON.length == 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _cache[6] || (_cache[6] = _createTextVNode(" Filters "))
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass([{ 'active-tab': _ctx.viewMode === 'tiles', 'inactive-tab': _ctx.viewMode !== 'tiles' }, "flex items-center justify-center rounded font-opensans font-bold text-sm leading-3 cursor-pointer w-28 h-8"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ClickedMethod('Tiles')))
          }, [
            (_ctx.viewMode === 'tiles')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[7] || (_cache[7] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "mr-1"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[8] || (_cache[8] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "mr-1"
                  }, null, -1)
                ]))),
            _cache[9] || (_cache[9] = _createTextVNode(" Tiles "))
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass([{ 'active-tab': _ctx.viewMode === 'list', 'inactive-tab': _ctx.viewMode !== 'list' }, "flex items-center justify-center rounded font-opensans font-bold text-sm leading-3 cursor-pointer w-28 h-8"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ClickedMethod('List')))
          }, [
            (_ctx.viewMode === 'list')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[10] || (_cache[10] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "mr-1"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[11] || (_cache[11] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "mr-1"
                  }, null, -1)
                ]))),
            _cache[12] || (_cache[12] = _createTextVNode(" List "))
          ], 2)
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "headerText mt-3" }, " Document management, often referred to as Document Management Systems (DMS), is the use of a computer system and software to store, manage, and track electronic documents and electronic images of paper-based information captured through the use of a document scanner. Document management is how your organization stores, manages, and tracks its electronic documents. According to ISO 12651-2, a document is \"recorded information or object which can be treated as a unit.\" ", -1)),
    (_ctx.viewMode === 'tiles')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Search folders and documents",
              class: _normalizeClass(["inputboxstyling", { 'bg-icon': !_ctx.searchText }]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event)),
              onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findFoldersAndFiles(_ctx.searchText)))
            }, null, 34), [
              [_vModelText, _ctx.searchText]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.viewMode === 'tiles')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_ctx.dotsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_dots_loader)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.searchText === '' || _ctx.searchText === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", null, [
                          (_ctx.publishedFiles.length !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishedFiles, (document) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: document,
                                    class: "p-4 flex flex-col items-center justify-center"
                                  }, [
                                    _createElementVNode("div", {
                                      class: "relative cursor-pointer",
                                      onClick: ($event: any) => (_ctx.routeToFilesList(document))
                                    }, [
                                      _cache[14] || (_cache[14] = _createElementVNode("svg", {
                                        width: "120",
                                        height: "97",
                                        viewBox: "0 0 120 97",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M108 12H54L42 0H12C5.4 0 1.40625e-07 5.4 0 12V36H120V24C120 17.4 114.6 12 108 12Z",
                                          fill: "#FFA000"
                                        }),
                                        _createElementVNode("path", {
                                          d: "M108 12.0117H12C5.4 12.0117 1.40625e-07 17.4117 0 24.0117V84.0117C0 90.6117 5.4 96.0117 12 96.0117H108C114.6 96.0117 120 90.6117 120 84.0117V24.0117C120 17.4117 114.6 12.0117 108 12.0117Z",
                                          fill: "#FFCA28"
                                        }),
                                        _createElementVNode("rect", {
                                          x: "88",
                                          y: "74",
                                          width: "24",
                                          height: "14.1667",
                                          rx: "2",
                                          fill: "white"
                                        })
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("p", _hoisted_24, _toDisplayString(document.numberOfFiles), 1)
                                        ])
                                      ])
                                    ], 8, _hoisted_21),
                                    _createElementVNode("div", {
                                      class: "title-container",
                                      onMouseenter: ($event: any) => (_ctx.toolTipTrigger(document._id, $event)),
                                      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pop = false))
                                    }, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("p", null, _toDisplayString(document.title), 1)
                                      ])
                                    ], 40, _hoisted_25),
                                    (_ctx.pop && document._id === _ctx.hoveredIndex)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createElementVNode("div", _hoisted_28, [
                                            _cache[15] || (_cache[15] = _createElementVNode("img", {
                                              src: _imports_6,
                                              alt: "",
                                              class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                            }, null, -1)),
                                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1)),
                                            _createElementVNode("div", _hoisted_29, _toDisplayString(document.title), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, "No Records Found"))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (_ctx.filteredDocumentsDataJSON.length !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDocumentsDataJSON, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    _createElementVNode("div", {
                                      class: "p-4 flex flex-col items-center justify-center",
                                      onClick: ($event: any) => (item.type == 'folder' ? _ctx.folderClicked(item) : _ctx.fileClicked(item))
                                    }, [
                                      (item.type === 'folder')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                        : (item.type === 'file')
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                                          : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("p", null, _toDisplayString(item.name), 1)
                                      ])
                                    ], 8, _hoisted_34)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, "No Records Found"))
                      ]))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_newTable, {
                tableRowData: _ctx.publishedFiles,
                headersData: _ctx.documentDataHeaders,
                navigate: true,
                documentNavigateId: 10001,
                fileNavigateId: 10002,
                loadData: _ctx.dataLoading
              }, null, 8, ["tableRowData", "headersData", "loadData"])
            ])
          ]))
    ])
  ]))
}